/** Returns the short-lived grant issued after the Care View PIN is verified. */
export function getCareToken(hubId: string): string | null {
  try {
    return localStorage.getItem(`carePin_${hubId}`)
      || sessionStorage.getItem(`carePin_${hubId}`);
  } catch {
    return null;
  }
}

export function careTokenHeaders(hubId: string): Record<string, string> {
  const token = getCareToken(hubId);
  return token ? { "x-care-token": token } : {};
}